import { makeStyles, Theme } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";

const NON_SCROLLABLE_ELEMENTS_HEIGHT = 152;

export default makeStyles((theme: Theme) => ({
  root: {
    [theme.breakpoints.up(Breakpoints.SM_600)]: {
      borderLeft: `1px solid ${theme.palette.divider}`
    }
  },
  pageContent: {
    backgroundColor: theme.palette.common.white,
    display: "flex",
    flexDirection: "column"
  },
  pageHeader: {
    display: "none",
    alignItems: "center",
    justifyContent: "space-between",
    fontSize: 18,
    paddingLeft: 8,
    paddingRight: 8,
    height: 50,
    maxHeight: 50,
    boxShadow: "none",
    borderBottom: `1px solid ${theme.palette.divider}`,
    borderLeft: "none",
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      display: "flex",
      top: 0
    }
  },
  pageHeaderButtonCancel: {
    position: "absolute",
    left: 10,
    textTransform: "none",
    fontSize: 16,
    height: 32,
    color: theme.palette.primary.dark,
    [theme.breakpoints.up(Breakpoints.SX_720)]: {
      display: "none"
    }
  },
  pageHeaderTitle: {
    flex: 1,
    textAlign: "center"
  },
  title: {
    [theme.breakpoints.up(Breakpoints.SX_720)]: {
      display: "none"
    }
  },
  content: {
    padding: "8px 16px 24px",
    height: `calc(100dvh - ${NON_SCROLLABLE_ELEMENTS_HEIGHT}px)`,
    overflowY: "auto"
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: 20,
    maxWidth: 436,
    paddingTop: 46,
    margin: "0 auto",
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      paddingTop: 16
    }
  },
  formTitle: {
    fontSize: 16
  },
  formField: {
    flex: 0
  },
  actions: {
    height: 88,
    borderTop: `1px solid ${theme.palette.text.hint}`,
    padding: 16,
    textAlign: "right",
    [theme.breakpoints.up(Breakpoints.SX_720)]: {
      padding: "16px 24px"
    }
  },
  actionsReviewButton: {
    minWidth: 188,
    height: 46,
    backgroundColor: theme.palette.secondary.dark,
    color: theme.palette.common.white,
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#5db491"
    },
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      width: "100%"
    }
  },
  actionsReviewButtonDisabled: {
    "&.Mui-disabled": {
      backgroundColor: theme.palette.grey[200]
    }
  }
}));
